<div
  *ngIf="isLoading"
  style="
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  "
>
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>

<div class="containerDialog" *ngIf="!isLoading">
  <div class="titleSecction">
    <div *ngIf="data.type == 'OBSERVACIONES'">
      <h4 class="titleModal">Añadir Observaciones</h4>
    </div>

    <div *ngIf="data.type == 'TIPODEUNIDAD'">
      <h4 class="titleModal">Cambiar Tipo de Unidad</h4>
    </div>

    <div *ngIf="data.type == 'INCIDENCIAS'" class="titleButton">
      <div class="title-container">
        <h4 class="titleModal">Incidencias Operativas</h4>
        <h5 class="subtitleModal">
          File: {{ data.activity.fileNumber || "N/A" }}
        </h5>
        <h5 class="subtitleModal">
          Actividad: {{ data.activity.day || "N/A" }} -
          {{ data.activity.dayName || "N/A" }}
        </h5>
        <p class="descriptionModal">
          Estas incidencias se pueden reportar solo para itinerarios o también
          para servicios. Las filas sin información de servicio corresponden a
          incidencias generales del itinerario.
        </p>
      </div>
      <div class="button-container">
        <button
          mat-raised-button
          [class.spinnerButton]="isLoading"
          class="buttonThird"
          (click)="openDialogAddOpIncident()"
        >
          Registrar Incidencia
        </button>
      </div>
    </div>

    <div *ngIf="data.type == 'ALERGIAS'">
      <h4 class="titleModal">Alergias</h4>
    </div>

    <div *ngIf="data.type == 'RESTRICCIONES'">
      <h4 class="titleModal">Restricciones Alimenticias</h4>
    </div>

    <div *ngIf="data.type == 'CONDICIONESMEDICAS'">
      <h4 class="titleModal">Condiciones Médicas / Alergias</h4>
    </div>
  </div>

  <div *ngIf="data.type == 'OBSERVACIONES'" class="toggleSecction">
    <div class="divToggle">
      <div class="labelToggle">Ver Observaciones por servicio</div>
      <mat-slide-toggle
        labelPosition="after"
        style="display: flex; align-items: center; gap: 10px"
        [checked]="tablaTypeObs === 'obsService'"
        (change)="changeTablaTypeObs('obsService')"
      >
      </mat-slide-toggle>
    </div>

    <div class="divToggle">
      <div class="labelToggle">Ver Observaciones por Actividad</div>
      <mat-slide-toggle
        labelPosition="after"
        style="display: flex; align-items: center; gap: 10px"
        [checked]="tablaTypeObs === 'obsActividad'"
        (change)="changeTablaTypeObs('obsActividad')"
      >
      </mat-slide-toggle>
    </div>
  </div>

  <div
    *ngIf="type == 'INCIDENCIAS'"
    class="divButtons"
    class="example-container mat-elevation-z8"
  >
    <mat-table [dataSource]="opIncidentTableSource" matSort>
      <div
        *ngIf="opIncidentTableSource.data.length === 0"
        class="no-data-container"
      >
        <i-tabler name="info-circle" class="no-data-icon"></i-tabler>
        <p class="no-data-text">No hay incidencias operativas para mostrar.</p>
      </div>

      <ng-container matColumnDef="createdAt">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          Fecha de Creación
        </mat-header-cell>
        <mat-cell *matCellDef="let opIncidentRow" class="bodyStyle">
          {{ opIncidentRow.createdAt | date: "dd/MM/yyyy HH:mm" }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="serviceName">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          Servicio
        </mat-header-cell>
        <mat-cell *matCellDef="let opIncidentRow" class="bodyStyle">
          {{ opIncidentRow.serviceName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="serviceType">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          Tipo de Servicio
        </mat-header-cell>
        <mat-cell *matCellDef="let opIncidentRow" class="bodyStyle">
          {{ opIncidentRow.serviceType | titlecase }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="reportedBy">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          Reportado por
        </mat-header-cell>
        <mat-cell *matCellDef="let opIncidentRow" class="bodyStyle">
          {{ opIncidentRow.reportedBy }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="description">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          Descripción
        </mat-header-cell>
        <mat-cell *matCellDef="let opIncidentRow" class="bodyStyle">
          {{ opIncidentRow.description }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="opIncidentType">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          Tipo de Incidencia
        </mat-header-cell>
        <mat-cell *matCellDef="let opIncidentRow" class="bodyStyle">
          {{ opIncidentRow.opIncidentType }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="incidentStatus">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          Estado de Incidencia
        </mat-header-cell>
        <mat-cell *matCellDef="let opIncidentRow" class="bodyStyle">
          {{ renameOpIncidentStatus(opIncidentRow.incidentStatus) }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="solutionDate">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          Fecha de Resolución
        </mat-header-cell>
        <mat-cell *matCellDef="let opIncidentRow" class="bodyStyle">
          {{ (opIncidentRow.solutionDate | date: "dd/MM/YYYY hh:mm") || "-" }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="solutionTime">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          Tiempo de Solución
        </mat-header-cell>
        <mat-cell *matCellDef="let opIncidentRow" class="bodyStyle">
          {{ opIncidentRow.solutionTime || "-" }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          Acciones
        </mat-header-cell>
        <mat-cell *matCellDef="let opIncidentRow" class="bodyStyle">
          {{ opIncidentRow.actions || "-" }}
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="opIncidentColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: opIncidentColumns"> </mat-row>
    </mat-table>
    <mat-paginator
      #showFirstLastButtons
      [pageSize]="5"
      [pageSizeOptions]="[5, 10, 25, 100]"
    ></mat-paginator>
  </div>

  <!-------------OBSERVACIONES TIPO DE UNIDAD------------------>

  <div class="mat-elevation-z8">
    <mat-table
      [dataSource]="dataTipoDeUnidad"
      matTableExporter
      *ngIf="type === 'TIPODEUNIDAD'"
    >
      <ng-container matColumnDef="nombreServicio">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          Nombre Servicio
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let element" class="bodyStyle">
          {{ element.nombreServicio }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="proveedor">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          Proveedor
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let element" class="bodyStyle">
          {{ element.objProvider?.nombre }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="tipoServicio">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          Tipo Servicio
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let element" class="bodyStyle">
          {{ element.tipoServicio }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="acciones">
        <mat-header-cell *matHeaderCellDef class="headerStyleLarge">
          {{ type === "TIPODEUNIDAD" ? "Tipo de Unidad" : "" }}
        </mat-header-cell>
        <mat-cell
          mat-cell
          *matCellDef="let element; let i = index"
          class="bodyStyleLarge"
        >
          <div *ngIf="type === 'TIPODEUNIDAD'" class="obs-cell-row">
            <div *ngIf="activeTextArea !== i" class="obs-cell-text">
              {{ formatTipoDeUnidad(element.tipoDeUnidad) || "-" }}
            </div>

            <mat-form-field
              appearance="outline"
              style="width: 70%"
              *ngIf="activeTextArea === i"
            >
              <textarea [(ngModel)]="tipoDeUnidad" matInput></textarea>
            </mat-form-field>
            <mat-icon
              *ngIf="activeTextArea !== i; else elseIcon"
              (click)="setActiveTextAreaTipoDeUnidad(i, element)"
              class="icon-color icon-edit"
            >
              edit
            </mat-icon>
            <ng-template #elseIcon>
              <mat-icon
                (click)="addTipoDeUniadToService(element)"
                class="icon-color icon-edit"
              >
                check
              </mat-icon>
            </ng-template>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="columnsTipoDeUnidad"></mat-header-row>
      <mat-row *matRowDef="let row; columns: columnsTipoDeUnidad"></mat-row>
    </mat-table>
  </div>
  <!-------------OBSERVACIONES Activity------------------>
  <div
    *ngIf="tablaTypeObs == 'obsActividad' && type == 'OBSERVACIONES'"
    class="mat-elevation-z8"
  >
    <mat-table [dataSource]="dataActivity" matTableExporter>
      <ng-container matColumnDef="dayName">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          Actividad
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let element" class="bodyStyle">
          {{ element.dayName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="agencia">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          Agencia
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let element" class="bodyStyle">
          {{ element.agencia }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="fileNumber">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          File
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let element" class="bodyStyle">
          {{ element.fileNumber }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="acciones">
        <mat-header-cell
          *matHeaderCellDef
          class="headerStyle"
          [ngClass]="
            type === 'OBSERVACIONES' ? 'headerStyleLarge' : 'headerStyle'
          "
        >
          {{ type === "OBSERVACIONES" ? "Observaciones" : "" }}
        </mat-header-cell>
        <mat-cell
          mat-cell
          *matCellDef="let element; let i = index"
          [ngClass]="type === 'OBSERVACIONES' ? 'bodyStyleLarge' : 'bodyStyle'"
        >
          <div *ngIf="type === 'OBSERVACIONES'" class="obs-cell-row">
            <div *ngIf="activeTextArea !== i" class="obs-cell-text">
              {{ element.obsActivity }}
            </div>

            <mat-form-field
              appearance="outline"
              style="width: 70%"
              *ngIf="activeTextArea === i"
            >
              <textarea [(ngModel)]="observaciones" matInput></textarea>
            </mat-form-field>
            <mat-icon
              *ngIf="activeTextArea !== i; else elseIcon"
              (click)="setActiveTextAreaObsAct(i, element)"
              class="icon-color icon-edit"
            >
              edit
            </mat-icon>
            <ng-template #elseIcon>
              <mat-icon
                (click)="updateObservacionToActivity(element)"
                class="icon-color icon-edit"
              >
                check
              </mat-icon>
            </ng-template>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="columnsActivity"></mat-header-row>
      <mat-row *matRowDef="let row; columns: columnsActivity"></mat-row>
    </mat-table>
  </div>

  <!-------------OBSERVACIONES SERVICE------------------>
  <div
    *ngIf="tablaTypeObs == 'obsService' && type == 'OBSERVACIONES'"
    class="mat-elevation-z8"
  >
    <mat-table [dataSource]="dataServices" matTableExporter>
      <!-- Position Column -->
      <ng-container matColumnDef="nombreServicio">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          Servicio
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let element" class="bodyStyle">
          {{ element.nombreServicio }}
        </mat-cell>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="tipoServicio">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          Tipo de Servicio
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let element" class="bodyStyle">
          {{ element.tipoServicio }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="proveedorServicio">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          Proveedor
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let element" class="bodyStyle">
          {{ element.objProvider.nombre }}
        </mat-cell>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="acciones">
        <mat-header-cell
          *matHeaderCellDef
          class="headerStyle"
          [ngClass]="
            type === 'OBSERVACIONES' ? 'headerStyleLarge' : 'headerStyle'
          "
        >
          {{ type === "OBSERVACIONES" ? "Observaciones" : "" }}
        </mat-header-cell>
        <mat-cell
          mat-cell
          *matCellDef="let element; let i = index"
          [ngClass]="type === 'OBSERVACIONES' ? 'bodyStyleLarge' : 'bodyStyle'"
        >
          <div *ngIf="type === 'OBSERVACIONES'" class="obs-cell-row">
            <div *ngIf="activeTextArea !== i" class="obs-cell-text">
              {{ element.observaciones }}
            </div>

            <mat-form-field
              appearance="outline"
              style="width: 70%"
              *ngIf="activeTextArea === i"
            >
              <textarea [(ngModel)]="observaciones" matInput></textarea>
            </mat-form-field>
            <mat-icon
              *ngIf="activeTextArea !== i; else elseIcon"
              (click)="setActiveTextAreaObsSer(i, element)"
              class="icon-color icon-edit"
            >
              edit
            </mat-icon>
            <ng-template #elseIcon>
              <mat-icon
                (click)="updateObservacionToService(element)"
                class="icon-color icon-edit"
              >
                check
              </mat-icon>
            </ng-template>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="columnsTable"></mat-header-row>
      <mat-row *matRowDef="let row; columns: columnsTable"></mat-row>
    </mat-table>
    <mat-paginator
      #showFirstLastButtons
      [pageSize]="5"
      [pageSizeOptions]="[5, 10, 25, 100]"
    ></mat-paginator>
  </div>
  <!------------------------------->

  <!--------------RESTRICCIONES----------------->
  <div *ngIf="type == 'RESTRICCIONES'" class="mat-elevation-z8">
    <mat-table [dataSource]="dataServices" matTableExporter>
      <ng-container matColumnDef="nombrePax">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          Nombre
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let element" class="bodyStyle">
          {{ element?.pasajero?.firstName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="apellidoPax">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          Apellido
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let element" class="bodyStyle">
          {{ element?.pasajero?.lastName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="acciones">
        <mat-header-cell
          *matHeaderCellDef
          class="headerStyle"
          [ngClass]="
            type === 'RESTRICCIONES' ? 'headerStyleLarge' : 'headerStyle'
          "
        >
          {{ type === "RESTRICCIONES" ? "Restricciones" : "" }}
        </mat-header-cell>
        <mat-cell
          mat-cell
          *matCellDef="let pax; let i = index"
          [ngClass]="type === 'RESTRICCIONES' ? 'bodyStyleLarge' : 'bodyStyle'"
        >
          <div *ngIf="type === 'RESTRICCIONES'" class="obs-cell-row">
            <div *ngIf="activeTextArea !== i" class="obs-cell-text">
              {{ pax.pasajero?.restriccionesAlimentarias }}
            </div>

            <mat-form-field
              appearance="outline"
              style="width: 70%"
              *ngIf="activeTextArea === i"
            >
              <textarea [(ngModel)]="restricciones" matInput></textarea>
            </mat-form-field>
            <mat-icon
              *ngIf="activeTextArea !== i; else elseIcon"
              (click)="setActiveTextArea(i, pax)"
              class="icon-color icon-edit"
            >
              edit
            </mat-icon>
            <ng-template #elseIcon>
              <mat-icon
                (click)="
                  updateRestriccionAlimentariaToPaxItineraryActivities(pax)
                "
                class="icon-color icon-edit"
              >
                check
              </mat-icon>
            </ng-template>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row
        *matHeaderRowDef="columnsRestriccionTable"
      ></mat-header-row>
      <mat-row *matRowDef="let row; columns: columnsRestriccionTable"></mat-row>
    </mat-table>
    <mat-paginator
      #showFirstLastButtons
      [pageSize]="5"
      [pageSizeOptions]="[5, 10, 25, 100]"
    ></mat-paginator>
  </div>
  <!------------------------------->

  <!--------------CONDICIONES MEDICAS----------------->
  <div *ngIf="type == 'CONDICIONESMEDICAS'" class="mat-elevation-z8">
    <mat-table [dataSource]="dataServices" matTableExporter>
      <ng-container matColumnDef="nombrePax">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          Nombre
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let element" class="bodyStyle">
          {{ element?.pasajero?.firstName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="apellidoPax">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          Apellido
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let element" class="bodyStyle">
          {{ element?.pasajero?.lastName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="acciones">
        <mat-header-cell
          *matHeaderCellDef
          class="headerStyle"
          [ngClass]="
            type === 'CONDICIONESMEDICAS' ? 'headerStyleLarge' : 'headerStyle'
          "
        >
          {{ type === "CONDICIONESMEDICAS" ? "Condiciones Médicas" : "" }}
        </mat-header-cell>
        <mat-cell
          mat-cell
          *matCellDef="let pax; let i = index"
          [ngClass]="
            type === 'CONDICIONESMEDICAS' ? 'bodyStyleLarge' : 'bodyStyle'
          "
        >
          <div *ngIf="type === 'CONDICIONESMEDICAS'" class="obs-cell-row">
            <div *ngIf="activeTextArea !== i" class="obs-cell-text">
              {{ pax.pasajero?.condicionesMedicas }}
            </div>

            <mat-form-field
              appearance="outline"
              style="width: 70%"
              *ngIf="activeTextArea === i"
            >
              <textarea [(ngModel)]="newCondition" matInput></textarea>
            </mat-form-field>
            <mat-icon
              *ngIf="activeTextArea !== i; else elseIcon"
              (click)="setActiveTextArea(i, pax)"
              class="icon-color icon-edit"
            >
              edit
            </mat-icon>
            <ng-template #elseIcon>
              <mat-icon
                (click)="updateCondicionMedicaToPaxToItinerary(pax)"
                class="icon-color icon-edit"
              >
                check
              </mat-icon>
            </ng-template>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row
        *matHeaderRowDef="columnsRestriccionTable"
      ></mat-header-row>
      <mat-row *matRowDef="let row; columns: columnsRestriccionTable"></mat-row>
    </mat-table>
    <mat-paginator
      #showFirstLastButtons
      [pageSize]="5"
      [pageSizeOptions]="[5, 10, 25, 100]"
    ></mat-paginator>
  </div>
  <!------------------------------->

  <!--------------ALERGIAS----------------->
  <div *ngIf="type == 'ALERGIAS'" class="mat-elevation-z8">
    <mat-table [dataSource]="dataServices" matTableExporter>
      <ng-container matColumnDef="nombrePax">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          Nombre
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let element" class="bodyStyle">
          {{ element?.pasajero?.firstName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="apellidoPax">
        <mat-header-cell *matHeaderCellDef class="headerStyle">
          Apellido
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let element" class="bodyStyle">
          {{ element?.pasajero?.lastName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="acciones">
        <mat-header-cell
          *matHeaderCellDef
          class="headerStyle"
          [ngClass]="type === 'ALERGIAS' ? 'headerStyleLarge' : 'headerStyle'"
        >
          {{ type === "ALERGIAS" ? "Alergias" : "" }}
        </mat-header-cell>
        <mat-cell
          mat-cell
          *matCellDef="let pax; let i = index"
          [ngClass]="type === 'ALERGIAS' ? 'bodyStyleLarge' : 'bodyStyle'"
        >
          <div *ngIf="type === 'ALERGIAS'" class="obs-cell-row">
            <div *ngIf="activeTextArea !== i" class="obs-cell-text">
              {{ pax.pasajero?.alergias }}
            </div>

            <mat-form-field
              appearance="outline"
              style="width: 70%"
              *ngIf="activeTextArea === i"
            >
              <textarea [(ngModel)]="newAllergy" matInput></textarea>
            </mat-form-field>
            <mat-icon
              *ngIf="activeTextArea !== i; else elseIcon"
              (click)="setActiveTextArea(i, pax)"
              class="icon-color icon-edit"
            >
              edit
            </mat-icon>
            <ng-template #elseIcon>
              <mat-icon
                (click)="updateAllergyToItineraryActivities(pax)"
                class="icon-color icon-edit"
              >
                check
              </mat-icon>
            </ng-template>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row
        *matHeaderRowDef="columnsRestriccionTable"
      ></mat-header-row>
      <mat-row *matRowDef="let row; columns: columnsRestriccionTable"></mat-row>
    </mat-table>
    <mat-paginator
      #showFirstLastButtons
      [pageSize]="5"
      [pageSizeOptions]="[5, 10, 25, 100]"
    ></mat-paginator>
  </div>
  <!------------------------------->
  <div style="margin-top: 2rem" class="divCenter">
    <button class="buttonSecundary" (click)="close()">Cerrar</button>
  </div>
</div>
